<template>
  <form-layout :loading="isAddingCrewAssignment" @save="addCrewToSchedule">
    <template #title>
      <h1 class="uppercase">
        Add Crew to Schedule
      </h1>
    </template>
    <template #body>
      <bdg-text-field
        ref="crewIdentifier"
        name="Crew identifier"
        v-model="formData.crew_identifier"
        :disabled="typeof crew_identifier !== 'undefined'"
        required
      />

      <bdg-dropdown
        ref="projectId"
        name="Project name"
        :options="projects"
        placeholder="begin typing"
        v-model="formData.project_id"
        searchable
        required
      />

      <bdg-dropdown
        ref="contractId"
        name="Contract name"
        :options="contracts"
        placeholder="select one"
        v-model="formData.contract_id"
        required
      />

      <bdg-dropdown
        ref="workScopeItemId"
        name="Scope item"
        :options="formattedScopeItems"
        placeholder="select one"
        v-model="workScopeItemId"
        required
      />

      <bdg-dropdown
        ref="taskId"
        name="Scope item task"
        :options="tasks"
        placeholder="select one"
        v-model="formData.task_id"
        v-if="tasks && tasks.length"
      />

      <bdg-date-field
        ref="scheduledFor"
        name="Scheduled"
        placeholder="mm/dd/yyyy"
        v-model="formData.scheduled_for"
        multiple
        required
      />
    </template>
  </form-layout>
</template>

<script>
import FormLayout from "../views/layouts/FormLayout";
import BdgTextField from "./fields/BdgTextField";
import BdgDropdown from "./fields/BdgDropdown";
import BdgDateField from "./fields/BdgDateField";
import { validateRequiredRefs } from "../helpers";

export default {
  name: "AddCrewToScheduleForm",
  components: { BdgDateField, BdgDropdown, BdgTextField, FormLayout },
  props: {
    crew_identifier: {
      type: String,
      default: undefined
    },
    scheduled_for: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formData: {
        crew_identifier: this.crew_identifier,
        project_id: undefined,
        contract_id: undefined,
        work_scope_work_scope_item_id: undefined,
        task_id: undefined,
        scheduled_for: this.scheduled_for.slice()
      },
      workScopeItemId: undefined,
      requiredRefs: [
        "crewIdentifier",
        "projectId",
        "contractId",
        "workScopeItemId",
        "scheduledFor"
      ]
    };
  },
  computed: {
    projects() {
      const projects = this.$store.state.Projects.projects;

      if (projects) {
        return projects
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(project => {
            return {
              label: project.name,
              value: project.id
            };
          });
      }

      return projects;
    },
    selectedProjectId() {
      return this.formData.project_id;
    },
    contracts() {
      const contracts = this.$store.state.Contracts.contracts;
      if (contracts) {
        return contracts
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(contract => {
            return {
              label: contract.name,
              value: contract.id
            };
          });
      }
      return [];
    },
    selectedContractId() {
      return this.formData.contract_id;
    },
    scopeItems() {
      const scopes = this.$store.state.Contracts.JobTracking.contractScopeItems;
      if (scopes) {
        return scopes.reduce((acc, scope) => {
          acc.push(
            ...scope.work_scope_items.map(wsi => {
              wsi.name = `${scope.name || "Unnamed Scope Document"} - ${
                wsi.name
              }`;
              return wsi;
            })
          );
          return acc;
        }, []);
      }
      return [];
    },
    formattedScopeItems() {
      if (this.scopeItems) {
        const scopeItems = this.scopeItems.slice();
        return scopeItems
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(item => {
            return {
              label: item.name,
              value: item.id
            };
          });
      }
      return [];
    },
    selectedScopeItem() {
      if (this.scopeItems && this.workScopeItemId) {
        return this.scopeItems.find(si => si.id === this.workScopeItemId);
      }
      return null;
    },
    tasks() {
      if (this.selectedScopeItem && this.selectedScopeItem.tasks) {
        const tasks = this.selectedScopeItem.tasks.slice();
        return tasks
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(task => {
            return {
              label: task.name,
              value: task.id
            };
          });
      }
      return [];
    },
    isAddingCrewAssignment() {
      return this.$store.state.Dashboard.isAddingCrewAssignment;
    }
  },
  watch: {
    selectedProjectId(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.$store.dispatch("getContracts", newVal);
      }
    },
    selectedContractId(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.$store.dispatch("getContractScopeItems", {
          contractId: newVal,
          unassignedOnly: true
        });
      }
    },
    selectedScopeItem(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.formData.work_scope_work_scope_item_id = newVal.pivot.id;
      }
    }
  },
  created() {
    this.$store.dispatch("getProjects", "active");
  },
  methods: {
    validate() {
      return validateRequiredRefs(this, true);
    },
    addCrewToSchedule() {
      if (!this.validate()) {
        return;
      }

      this.$store.dispatch("addCrewAssignment", this.formData);
    }
  }
};
</script>

<style scoped></style>
